module.exports = __webpack_public_path__ + "media/images/appLogo-6e0156cd0e555e6ea8aeb623c884a12c.jpg";